module.exports = __webpack_public_path__ + "media/images/home/notebook-dda04025de24b800aa9de7bc051cb0d3.png";